module.exports = __webpack_public_path__ + "img/kornieckaya.6e36e79c.jpg";